import { FormControl, FormLabel } from '@mui/material'
import TextField from '@mui/material/TextField'

import { useAppSelector } from 'redux/Hook'

const DemographicQuestion = ({
  question,
  id,
  yearOnlyDate,
}: {
  question: string
  id: string
  yearOnlyDate: boolean
}) => {
  const { signupAnswers: { answers = [] } = [] } =
    useAppSelector((state) => state) || {}

  const value =
    yearOnlyDate && answers[id]?.value
      ? new Date(answers[id]?.value).getFullYear()
      : answers[id]?.value

  return (
    <FormControl fullWidth>
      <FormLabel> {question} </FormLabel>
      <TextField
        key={id}
        fullWidth
        value={value}
        InputProps={{
          readOnly: true,
        }}
        variant="standard"
        data-cy="location-question"
      />
    </FormControl>
  )
}

export default DemographicQuestion
